import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      hasError : false,
    };
  }

  componentDidCatch (error, info) {
    console.log('dddddd');
    this.setState({ hasError: true })
  }

  render () {
    return this.state.hasError
      ? <span>error</span>
      : this.props.children
  }

}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/search/ui/error_boundary.js